
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-detalles';
    import { Curso } from '@/__env/lib/Cursos';
    import { Respuesta } from '@/__env/lib/Cursos/Respuestas';
    import { Opcion } from '@/__env/lib/Cursos/Preguntas/Opciones';
    import { OpcionElegida } from '@/__env/lib/Cursos/Respuestas/Respuesta.lib';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return this.Controlador.Curso; }

        @Prop()
        public Opcion: Opcion;
        @Prop()
        public Respuesta: Respuesta;
        public get Elegida(): OpcionElegida
        {
            return this.Respuesta.OpcionesElegidas.find( x => x.Opcion == this.Opcion.Id );
        }

        public Estado: string = 'cargando';


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {
            this.Estado = this.Controlador.Vista.Estado;
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );

        }


    }
